<template>
  <div class="preguntas-frecuentes text-center py-16 px-4 mx-auto" style="max-width: 900px">
    <h2 class="font-weight-bold text-center mb-4" style="font-size: 2.5rem; color: #2c3e50;">
      Preguntas Populares
    </h2>
    <p class="subtitle mb-10" style="color: #6b7280; font-size: 1.2rem; max-width: 700px; margin: 0 auto;">
      Mira lo que otros usuarios están preguntando antes de decidirse
    </p>
    
    <div class="mt-8 questions-container">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="mb-4 question-card"
        style="border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden;"
      >
        <div 
          class="question-header py-4 px-6 cursor-pointer"
          :class="{ 'active': selectedFAQ === i }"
          @click="toggleFAQ(i)"
        >
          <div class="d-flex align-center justify-space-between w-100">
            <span class="font-weight-medium" style="font-size: 1.125rem; color: #374151;">
              {{ item.question }}
            </span>
            <div class="icon-container">
              <svg 
                class="chevron-icon"
                :class="{ 'rotated': selectedFAQ === i }"
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2"
              >
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </div>
          </div>
        </div>
        <div 
          class="answer-content"
          :class="{ 'expanded': selectedFAQ === i }"
        >
          <div class="answer-inner py-6 px-6 text-left">
            <span 
              style="font-weight: 400; font-size: 1.1rem; color: #4B5563; line-height: 1.6;"
              v-html="item.answer"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQs",
  data() {
    return {
      selectedFAQ: null,
      items: [
        {
          question: "¿Tiene algún costo SeleAI?",
          answer: "Puedes usar SeleAI completamente gratis. Sin embargo, tenemos planes pagos accesibles con muchas más funciones y sin límites en la versión gratuita."
        },
        {
          question: "¿Cómo funciona?",
          answer: "SeleAI utiliza inteligencia artificial avanzada para analizar tus apuntes y materiales de estudio. A partir de ellos, genera cuestionarios personalizados, resúmenes concisos y actúa como un tutor personal que responde a tus preguntas específicas sobre el contenido que estás estudiando."
        },
        {
          question: "¿Puedo cancelar mi suscripción?",
          answer: "Sí, puedes cancelar tu suscripción en cualquier momento. Si cancelas, mantendrás el acceso a las funciones premium hasta el final del período de facturación actual. No se aplican cargos adicionales después de la cancelación."
        },
        // {
        //   question: "¿Puedo recomendar SeleAI?",
        //   answer: "¡Por supuesto! Nos encantaría que compartieras SeleAI con tus amigos y compañeros de clase. Incluso ofrecemos un programa de referidos donde puedes ganar crédito o extender tu suscripción cuando tus amigos se unen usando tu enlace de invitación."
        // },
        {
          question: "¿Puedo usar SeleAI en mi teléfono?",
          answer: "Sí, SeleAI está optimizado para dispositivos móviles. Puedes acceder a todas las funciones desde tu navegador móvil sin necesidad de descargar una aplicación. La experiencia es totalmente responsive y adaptada para pantallas pequeñas."
        }
      ]
    };
  },
  methods: {
    toggleFAQ(index) {
      this.selectedFAQ = this.selectedFAQ === index ? null : index;
    }
  }
};
</script>

<style scoped>
.preguntas-frecuentes {
    background-color: white !important;
}

.question-card {
  box-shadow: 0px 0px 0px 1px rgba(51, 151, 1,.06),0px 1px 1px 0px rgba(51, 151, 1,.04),0px 3px 3px 0px rgba(51, 151, 1, 0.03),0px 6px 4px 0px rgba(51, 151, 1,.02),0px 11px 4px 0px rgba(51, 151, 1,.01),0px 32px 24px -12px rgba(114,38,114,.06);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.question-header {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  background-color: white;
  user-select: none;
}

.question-header:hover {
  background-color: #f9fafb;
}

.question-header.active {
  background-color: #f9fdf9;
}

.cursor-pointer {
  cursor: pointer;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.chevron-icon {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  color: #9ca3af;
}

.chevron-icon.rotated {
  transform: rotate(180deg);
  color: #4dd453;
}

.answer-content {
  max-height: 0;
  overflow: hidden;
  background-color: #f9fdf9;
  transition: max-height 0.4s cubic-bezier(0.25, 0.8, 0.5, 1), 
              opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  opacity: 0;
}

.answer-content.expanded {
  max-height: 500px;
  opacity: 1;
}

.answer-inner {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.subtitle {
  max-width: 700px;
  margin: 0 auto;
}

.questions-container {
  background-color: transparent;
}

/* Utility classes */
.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-space-between {
  justify-content: space-between;
}

.w-100 {
  width: 100%;
}

.text-left {
  text-align: left;
}

.font-weight-medium {
  font-weight: 500;
}

.mb-4 {
  margin-bottom: 1rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.text-center {
  text-align: center;
}
</style>
